import React, { useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import ClassIcon from "@material-ui/icons/Class";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { withRouter } from "react-router-dom";
import WidgetsIcon from "@material-ui/icons/Widgets";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import LanguageIcon from "@material-ui/icons/Language";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Logoimage } from "../../../assets/index";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import BusinessIcon from "@material-ui/icons/Business";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { invokeApi } from "../../../bl_libs/ApiCalling";
import AddBoxIcon from "@material-ui/icons/AddBox";
import SettingsIcon from "@material-ui/icons/Settings";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ErrorIcon from "@material-ui/icons/Error";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import clsx from "clsx";
import "../../../assets/css/minimal.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const drawerWidth = 280;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    "&.MuiAppBar-colorPrimary": {
      backgroundColor: "black",
    },
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  iconscolor: {
    color: "#601124",
  },
  dwr: {
    "&.MuiListItem-button:hover": {
      backgroundColor: "white",
    },
  },
  mnu: {
    cursor: "pointer",
  },
  menuclr: {
    backgroundColor: "#e9e7e752",
  },
  lg: {},
}));

function Appbar(props) {
  console.log(props);
  const classes = useStyles();
  const theme = useTheme();
  const [islogout, setlogout] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [menu, setmenu] = React.useState("");
  const [dashboard, setDashboard] = React.useState("Dashboard");
  const [text, settext] = React.useState("Service Area");
  const [Itemtext, setItemtext] = React.useState("Items");
  const [Extraitemtext, setExtraitemtext] = React.useState("Extra Items");
  const [movesize, setMovesize] = React.useState("Move size");
  const [companylist, setCompanyList] = React.useState("Company List");
  const [forman, setForman] = React.useState("Forman");
  const [customer, setCustmer] = React.useState("Customer List");
  const [request, setRequest] = React.useState("Requests");

  const handleClose = () => {
    setlogout(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logout = () => {
    setlogout(true);
  };

  const serverlogout = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/app_api/log_out",
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
    });
    return true;
  };
  const handleagreelogout = () => {
    setlogout(false);
    if (serverlogout()) {
      localStorage.clear();
      props.history.push("/login");
    }
  };
  useEffect(() => {
    const location = window.location.pathname;

    if (location === "/admin") {
      setmenu("Dashboard");
    } else if (
      location.search("/service-area") > 0 ||
      location.search("/add-service") > 0 ||
      location.search("/edit-service") > 0
    ) {
      setmenu("Service Area");
    } else if (location.search("wishlist-area") > 0) {
      setmenu("wishlist-area");
    } else if (
      location.search("/items") > 0 ||
      location.search("/edit-item") > 0 ||
      location.search("/add-items") > 0
    ) {
      setmenu("Items");
    } else if (
      location.search("/extra-items") > 0 ||
      location.search("/add-extra-items") > 0 ||
      location.search("/edit-extra-items") > 0
    ) {
      setmenu(Extraitemtext);
    } else if (location.search("move") > 0) {
      setmenu(movesize);
    } else if (location.search("/request") > 0) {
      setmenu("Requests");
    } else if (location.search("/customer-list") > 0) {
      setmenu(customer);
    } else if (location.search("/all-transactions") > 0) {
      setmenu("Transactions");
    } else if (location.search("/lams-transactions") > 0) {
      setmenu("LAMS-Transactions");
    } else if (location.search("/settings") > 0) {
      setmenu("settings");
    } else if (location.search("/phone-error-logs") > 0) {
      setmenu("phone-error-logs");
    } else if (location.search("/subscription-plans") > 0) {
      setmenu("subscription-plans");
    } else if (location.search("documents") > 0) {
      setmenu("documents");
    }
  }, [window.location.pathname]);

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={
                clsx(classes.menuButton, open && classes.hide) + " remove-focus"
              }
            >
              <MenuIcon />
            </IconButton>
            <img
              src={Logoimage}
              height={"48px"}
              onClick={() => props.history.push("/")}
              className={classes.lg + " pointer-point"}
            />
          </Toolbar>
        </AppBar>

        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose} className="remove-focus">
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>
            <ListItem
              style={
                dashboard === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"service area"}
              onClick={() => {
                setmenu("Dashboard");
                setDashboard("Dashboard");
                props.history.push("/admin");
              }}
            >
              <ListItemIcon
                style={
                  dashboard === menu ? { color: "white" } : { color: "#c4314b" }
                }
              >
                {" "}
                <DashboardIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={dashboard} className={classes.txt} />
            </ListItem>
            <ListItem
              style={
                text === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"service area"}
              onClick={() => {
                setmenu("Service Area");
                settext("Service Area");
                props.history.push("/admin/service-area");
              }}
            >
              <ListItemIcon
                style={
                  text === menu ? { color: "white" } : { color: "#c4314b" }
                }
              >
                {" "}
                <LanguageIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={text} className={classes.txt} />
            </ListItem>

            <ListItem
              style={
                menu === "wishlist-area"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"whishlist-area"}
              onClick={() => {
                setmenu("wishlist-area");
                props.history.push("/admin/wishlist-area");
              }}
            >
              <ListItemIcon
                style={
                  "wishlist-area" === menu
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                {" "}
                <LanguageIcon />{" "}
              </ListItemIcon>
              <ListItemText primary="Wishlist Area" className={classes.txt} />
            </ListItem>

            <ListItem
              style={
                Itemtext === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"Items"}
              onClick={() => {
                setmenu("Items");
                setItemtext("Items");
                props.history.push("/admin/items");
              }}
            >
              <ListItemIcon
                style={
                  Itemtext === menu ? { color: "white" } : { color: "#c4314b" }
                }
              >
                {" "}
                <WidgetsIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={Itemtext} className={classes.txt} />
            </ListItem>
            <ListItem
              style={
                Extraitemtext === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"ExtraItems"}
              onClick={() => {
                setmenu("Extra items");
                setExtraitemtext("Extra items");
                props.history.push("/admin/extra-items");
              }}
            >
              <ListItemIcon
                style={
                  Extraitemtext === menu
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                {" "}
                <ClassIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={Extraitemtext} className={classes.txt} />
            </ListItem>
            <ListItem
              style={
                movesize === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"ExtraItems"}
              onClick={() => {
                setmenu("Move size");
                setMovesize("Move size");
                props.history.push("/admin/move-size");
              }}
            >
              <ListItemIcon
                style={
                  movesize === menu ? { color: "white" } : { color: "#c4314b" }
                }
              >
                {" "}
                <EmojiTransportationIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={movesize} className={classes.txt} />
            </ListItem>

            <ListItem
              style={
                companylist === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"CompanyList"}
              onClick={() => {
                setmenu("Company List");
                setCompanyList("Company List");
                props.history.push("/admin/company-list");
              }}
            >
              <ListItemIcon
                style={
                  companylist === menu
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                {" "}
                <BusinessIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={companylist} className={classes.txt} />
            </ListItem>

            <ListItem
              style={
                customer === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"customer"}
              onClick={() => {
                setmenu("Customer List");

                props.history.push("/admin/customer-list");
              }}
            >
              <ListItemIcon
                style={
                  customer === menu ? { color: "white" } : { color: "#c4314b" }
                }
              >
                {" "}
                <AccountBoxIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={customer} className={classes.txt} />
            </ListItem>

            {/* All Transactions */}

            <ListItem
              style={
                menu === "Transactions"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              onClick={() => {
                setmenu("Transactions");
                props.history.push("/admin/all-transactions");
              }}
            >
              <ListItemIcon
                style={
                  menu === "Transactions"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <AttachMoneyIcon />{" "}
              </ListItemIcon>
              <ListItemText
                primary={"All Transactions"}
                className={classes.txt}
              />
            </ListItem>

            {/* EVOM Transactions */}

            <ListItem
              style={
                menu === "LAMS-Transactions"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              onClick={() => {
                setmenu("LAMS-Transactions");
                props.history.push("/admin/lams-transactions");
              }}
            >
              <ListItemIcon
                style={
                  menu === "LAMS-Transactions"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <AttachMoneyIcon />{" "}
              </ListItemIcon>
              <ListItemText
                primary={"LAMS Transactions"}
                className={classes.txt}
              />
            </ListItem>

            {/* Requests */}
            <ListItem
              style={
                request === menu
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"request"}
              onClick={() => {
                setmenu("Request");
                setRequest("Requests");
                props.history.push("/admin/request");
              }}
            >
              <ListItemIcon
                style={
                  request === menu ? { color: "white" } : { color: "#c4314b" }
                }
              >
                {" "}
                <AddBoxIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={request} className={classes.txt} />
            </ListItem>
            {/* documents */}

            {/* documents */}
            <ListItem
              style={
                menu === "documents"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              onClick={() => {
                setmenu("documents");
                props.history.push("/admin/documents");
              }}
            >
              <ListItemIcon
                style={
                  menu === "documents"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <SettingsIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={"Documents"} className={classes.txt} />
            </ListItem>

            {/* email-templates */}
            <ListItem
              style={
                menu === "email-templates"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              onClick={() => {
                setmenu("email-templates");
                props.history.push("/admin/email-templates");
              }}
            >
              <ListItemIcon
                style={
                  menu === "email-templates"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <SettingsIcon />{" "}
              </ListItemIcon>
              <ListItemText
                primary={"Email Templates"}
                className={classes.txt}
              />
            </ListItem>

            {/* phone-error-logs */}
            <ListItem
              style={
                menu === "phone-error-logs"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"phone-error-logs"}
              onClick={() => {
                setmenu("phone-error-logs");
                props.history.push("/admin/phone-error-logs");
              }}
            >
              <ListItemIcon
                style={
                  menu === "phone-error-logs"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <ErrorIcon />{" "}
              </ListItemIcon>
              <ListItemText
                primary={"Phone Error Logs"}
                className={classes.txt}
              />
            </ListItem>

            {/* Subscription plans */}

            <ListItem
              style={
                menu === "subscription-plans"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              onClick={() => {
                setmenu("subscription-plans");
                props.history.push("/admin/subscription-plans");
              }}
            >
              <ListItemIcon
                style={
                  menu === "subscription-plans"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <LocalAtmIcon />{" "}
              </ListItemIcon>
              <ListItemText
                primary={"Subscription Plans"}
                className={classes.txt}
              />
            </ListItem>
            {/* Settings */}

            <ListItem
              style={
                menu === "settings"
                  ? { backgroundColor: "black", color: "white" }
                  : {}
              }
              button
              key={"request"}
              onClick={() => {
                setmenu("settings");
                props.history.push("/admin/settings");
              }}
            >
              <ListItemIcon
                style={
                  menu === "settings"
                    ? { color: "white" }
                    : { color: "#c4314b" }
                }
              >
                <SettingsIcon />{" "}
              </ListItemIcon>
              <ListItemText primary={"Settings"} className={classes.txt} />
            </ListItem>
          </List>

          <Divider />

          <List>
            {["Logout"].map((text, index) => (
              <ListItem button key={text}>
                <ListItemIcon>
                  {index % 2 === 0 ? <PowerSettingsNewIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} onClick={logout} />
              </ListItem>
            ))}
          </List>
        </Drawer>
        <Dialog
          open={islogout}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{`Are you sure you want to logout?`}</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              No
            </Button>
            <Button onClick={handleagreelogout} color="primary">
              Logout
            </Button>
          </DialogActions>
        </Dialog>
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          <div className={classes.drawerHeader} />
          {props.children}
        </main>
      </div>
    </>
  );
}
export default withRouter(Appbar);
